<div *ngIf="!loader">
  <super-title [text]="'Association des documents du lot'" [buttons]="buttonTitle" class="mb-5 title"></super-title>

  <ng-container *ngIf="scan">
    <i-scan-v17 [title]="scan.name" [(scan)]="scan" [splitActions]="buttonsAction"
      (onScanSplitActionClick)="onScanSplitActionClick($event)"
      (clickDetailsCard)="clickDetailsCard($event)"></i-scan-v17>
  </ng-container>
</div>

<p-confirmDialog [header]="'confirm.confirmHeader' | translate" icon="pi pi-exclamation-triangle"
  [acceptLabel]="'Yes' | translate" [rejectLabel]="'No' | translate"></p-confirmDialog>

<ngx-spinner [name]="'spinnerScan'" bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="square-jelly-box"
  [fullScreen]="true">
  <p style="color: white">
    {{ 'saveFileProgress' | translate }}... {{ spinnerCountSave }}/{{ spinnerCountTotal }}
  </p>
</ngx-spinner>

<app-search-modal-scan *ngIf="openEditDescription" [infosCard]="infosCard" [guid]="modifyDetailSplitGuid"
  [openEditDescription]="openEditDescription" (closeModal)="openEditDescription = false; newDescription($event)">
</app-search-modal-scan>